export const tuesdayAbbreviatedLowercase = "DC9Ag";
export default {tuesdayAbbreviatedLowercase};